import MonthColumnHeader from './MonthColumnHeader';

export default MonthColumnHeader;
